// 把 endpoint 归一为 host（去 scheme / 尾斜杠）后拼回完整 endpoint。
export const buildEndpoint = (rawEndpoint: string, useSSL: boolean, port: number | null): string => {
  const scheme = useSSL ? 'https' : 'http'
  const host = rawEndpoint
    .replace(/^https?:\/\//, '')
    .replace(/\/+$/, '')
  return port ? `${scheme}://${host}:${port}` : `${scheme}://${host}`
}

export const resolveEndpointUseSSL = (rawEndpoint: string, configuredUseSSL?: string): boolean => {
  if (rawEndpoint.startsWith('http://')) return false
  if (rawEndpoint.startsWith('https://')) return true
  return configuredUseSSL !== 'false'
}
